import React from 'react';
import { EditableComponent } from '@adobe/aem-react-editable-components';

import { OCardCarouselCombo as OCardCarouselComboComp } from '@marriott/mi-web-ui-kit';
import clsx from 'clsx';

export const OCardCarouselComboConfig = {
  emptyLabel: 'OCardCarouselCombo',
  isEmpty: () => true,
  resourceType: `${process.env['NEXT_PUBLIC_AEM_SITE']}/components/content/o-card-carousel-combo`,
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const OCardCarouselCombo = (props: any) => {
  const model = props.model || {};
  const { styleclass, componentId } = model;

  return (
    <div
      data-testid="o-card-carousel-combo-comp"
      data-component-name="o-card-carousel-combo"
      id={componentId}
      className={clsx(styleclass)}
    >
      <EditableComponent config={OCardCarouselComboConfig} {...props}>
        <OCardCarouselComboComp {...props} />
      </EditableComponent>
    </div>
  );
};
